export default __webpack_public_path__ + "static/media/piasek.a0ab9369.png";